import { render, staticRenderFns } from "./StoresPicker.vue?vue&type=template&id=1027fffd&scoped=true&"
import script from "./StoresPicker.vue?vue&type=script&lang=ts&"
export * from "./StoresPicker.vue?vue&type=script&lang=ts&"
import style0 from "./StoresPicker.vue?vue&type=style&index=0&id=1027fffd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027fffd",
  null
  
)

export default component.exports